"use strict";
angular.module("weixinEditPageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('wxeditpage', {
    url: '/wxeditpage?wxmetadataid&wxchnldocid&wxchannelid&wxplatform&isawaitrevise',//isawaitrevise->待修订
    views: {
      '': {
        templateUrl: './editingCenter/weixin/editPage/editPage_tpl.html',
        controller: 'weixinEditPageCtrl'
      }
    }
  });
}]);
